import { ExpandedCourse, useCoursesLoaderData } from "./coursesLoader";

export default function useFindCourse({
  courseId,
}: {
  courseId: string | number;
}): ExpandedCourse | undefined {
  const { courses } = useCoursesLoaderData();
  return courses.find((course) => course.id === courseId);
}
